export default __webpack_public_path__ + "static/media/agriculture.c6f0f00f.jpg";